module.exports = __webpack_public_path__ + "static/media/10.5e37fa8f.jpg";